module.exports = __webpack_public_path__ + "img/scott-webb-GQD3Av_9A88-unsplash.83f3204e.jpg";